module.exports = __webpack_public_path__ + "static/media/background.30f7d9cd.jpg";